import { PopupProps } from './search-popup';
import css from './menu-modal.module.scss';
import Modal from 'src/components/common/modal/modal';
import { CustomPageMenuItem, MenuItems } from 'src/types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';

export default function MoreMenuPopup({
  dropdownItems,
  onOpen,
  onClose,
  trigger
}: Readonly<PopupProps<CustomPageMenuItem>>) {
  const items = dropdownItems?.map((c: CustomPageMenuItem) => {
    return {
      title: c.title,
      path: `pages/${c.slug}`
    };
  });

  return (
    <Modal onOpen={onOpen} onClose={onClose} trigger={trigger} closeOnDocumentClick={true}>
      {(close: () => void) => (
        <div className={css.menuPopup}>
          <div className={css.container}>
            <div className={classNames(css.pages, css.menuCards)}>
              <ul className={css.serviceCards}>
                {items?.map((item: MenuItems) => (
                  <li key={item.title} className={css.card} onClick={close} /*NOSONAR*/>
                    <NavLink to={item.path}>
                      {item.title} <span>&#10095;</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
}
